import React from 'react'
import { motion } from 'framer-motion'
import { useLocation } from 'react-router-dom'
import ArrowLinks from '@/components/shared/components/arrowLinks'
import useUtils from '@/hooks/useUtils'
import PropTypes from 'prop-types'
// styles
import '../styles.header.scss'

const ContainerLinks = (props) => {
  const { iconLogo, menusHeader, changeHoverLink } = props
  const location = useLocation()
  const { device } = useUtils()
  const { pathname } = location

  const parseLink =
    pathname === '/'
      ? 'home'
      : pathname
          .replace(/^\/|\/$/g, '')
          .replace(/-/g, ' ')
          .toLowerCase()

  const namePage = (name) => {
    const newName = name
      .replace(/&#038;/g, '') // Reemplaza &#038; con nada
      .replace(/\s+/g, ' ') // Reemplaza múltiples espacios con un solo espacio
      .toLowerCase()

    return newName
  }

  const pathLink = (url) => {
    let parsedUrl = new URL(url)
    let path = parsedUrl.pathname

    return path
  }

  return (
    <motion.div
      transition={{
        duration: 0.5,
      }}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="containerNavMenu"
    >
      <div className="containerLogoMenu">
        {device === 'desktop' ? <img className="imgLogo" {...iconLogo} /> : null}
      </div>
      <nav data-lenis-prevent>
        <ul>
          {menusHeader.map((value, key) => (
            <motion.li
              style={{
                position: 'relative',
              }}
              transition={{
                duration: 0.6,
                delay: key * 0.3 + 0.3,
              }}
              initial={{ opacity: 0, left: '70px' }}
              animate={{ opacity: 1, left: '0px' }}
              exit={{ opacity: 0 }}
              onMouseEnter={() => changeHoverLink(pathLink(value.url))}
              onMouseLeave={() => changeHoverLink(null)}
              key={`LinkHero_${key}`}
            >
              <ArrowLinks
                isActive={parseLink === namePage(value.content) ? true : false}
                textLink={<span dangerouslySetInnerHTML={{ __html: value.content }} />}
                href={value.url}
              />
            </motion.li>
          ))}
        </ul>
      </nav>
    </motion.div>
  )
}

ContainerLinks.propTypes = {
  iconLogo: PropTypes.any,
  menusHeader: PropTypes.array,
  changeHoverLink: PropTypes.func,
  isOpened: PropTypes.bool,
}

export default ContainerLinks
